export const getUserMasterData = (store) => store.UserMasterform.editData;

export const getDoctorList = (store) => store.UserMasterform.filters.doctor;
